import type { FC } from 'react';

import { useTranslation } from '@crehana/i18n';
import { clsx } from 'clsx';

import SocialButtons from '@/shared/components/AuthForm/components/SocialButtons';

import type { B2BLoginSocialButtonsProps } from './types';

const B2BLoginSocialButtons: FC<
  React.PropsWithChildren<B2BLoginSocialButtonsProps>
> = ({ className, nextUrl, label, children }) => {
  const { t } = useTranslation();

  return (
    <div className={clsx(className, 'tw-flex tw-items-center')}>
      <span className="tw-font-subtitle3 tw-mr-1.2 md:tw-mr-2.4">
        {label || t('CONTINUE_WITH', 'Continúa con:')}
      </span>
      <div>
        {children ?? (
          <SocialButtons
            authType="signIn"
            variant="minimal-3"
            hideFacebookLink
            hideFacebookButton
            nextUrl={nextUrl}
            showMicrosoftButton
          />
        )}
      </div>
    </div>
  );
};

export default B2BLoginSocialButtons;
